require("./js//Model.js");
require("./js//SimpleFAQ.js");
require("./js//FaqGridDetailsPanel.js");
require("./js//FaqGridPanel.js");
require("./js//FaqEditDialog.js");
require("./js//AdminPanel.js");
require("./js//FaqStatus.js");
require("./js//FaqStatusFilterModel.js");
require("./js//FaqType.js");
require("./js//FaqTypeFilterModel.js");
require("./js//SearchCombo.js");
require("./css//SimpleFAQ.css");
